import React from 'react'
import styles from './index.module.less'

const Mask: React.FC = () => {
  return <div className={styles.mask}></div>
}

export default Mask
